import React from 'react'
import arrow from './../../../UI/icons/Etapas/arrow.svg'
import arrowBlack from './../../../UI/icons/Etapas/arrow-black.svg'

interface Props{
    isEtapas: boolean
    isSidebarHidden: boolean
    proyecto: any,
    selectedEtapa: string
    handleSelectedEtapas: any
    selectedTorre: string
    handleSelectedTorres: any
    selectedAptoTipo: string
    handleSelectedAptosTipo: any
}

interface State{}

class EtapasSidebar extends React.Component<Props, State>{
    constructor(props: Props){
        super(props);
        this.state = {

        }
    }

    render(){
        return(
            <div className={this.props.isEtapas && !this.props.isSidebarHidden ? "etapas-show":"etapas-collapsed"}>
                <div className='etapas-header'>
                    Bienvenidos
                </div>
                <div className='etapas-information'>
                    {
                        this.props.proyecto.map((etapa: any, index: number) => 
                            <div className='etapas-container' key={index}>
                                <div className='etapas-btn'  onClick={() => {this.props.selectedEtapa === etapa.Nombre ? this.props.handleSelectedEtapas(""):this.props.handleSelectedEtapas(etapa.Nombre)}}>
                                    <div>{etapa.Nombre}</div>
                                    <img src={arrow} className={this.props.selectedEtapa === etapa.Nombre ? "selected-arrow":"deselected-arrow"}/>
                                </div>
                                {
                                    this.props.selectedEtapa === etapa.Nombre ?
                                    etapa.Torres.map((torre: any, indexTorre: number) => 
                                        <div className='torres-information' key={indexTorre}>
                                            <div className='torres-container' onClick={() => {this.props.selectedTorre === torre.Nombre ? this.props.handleSelectedTorres(""):this.props.handleSelectedTorres(torre.Nombre)}}>
                                                <div>{torre.Nombre}</div>
                                                <img src={arrow} className={this.props.selectedTorre === torre.Nombre ? "selected-arrow":"deselected-arrow"}/>
                                            </div>
                                            <hr/>
                                            {
                                                this.props.selectedTorre === torre.Nombre ?
                                                torre.AptosTipo.map((aptoTipo: any, indexApto: number) => 
                                                    <div className='aptos-tipo-information' key={indexApto}>
                                                        <div className='aptos-tipo-container' onClick={() => {this.props.selectedAptoTipo === aptoTipo.Nombre ? this.props.handleSelectedAptosTipo("","", []):this.props.handleSelectedAptosTipo(aptoTipo.Nombre, aptoTipo)}}>
                                                            <div>{aptoTipo.Nombre}</div>
                                                            <img src={arrow} className={this.props.selectedAptoTipo === aptoTipo.Nombre ? "selected-arrow":"deselected-arrow"}/>
                                                        </div>
                                                        {
                                                            this.props.selectedAptoTipo === aptoTipo.Nombre ?
                                                            <div className='areas-information'>
                                                            {
                                                                aptoTipo.Areas.map((area: any, indexArea: number) => 
                                                                <div className='areas-container' key={indexArea}>
                                                                    <div>{area.Nombre} : {area.Valor}</div>
                                                                </div>
                                                            )
                                                            }
                                                            </div>:null
                                                        }
                                                    </div>
                                                ): null
                                            }
                                        </div>
                                    ):null
                                }
                            </div>
                        )
                    }
                </div>
            </div>
        )
    }
}

export default EtapasSidebar